import { render, staticRenderFns } from "./OdsMenu.vue?vue&type=template&id=2c428ee5&scoped=true&"
import script from "./OdsMenu.vue?vue&type=script&lang=js&"
export * from "./OdsMenu.vue?vue&type=script&lang=js&"
import style0 from "./OdsMenu.vue?vue&type=style&index=0&id=2c428ee5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c428ee5",
  null
  
)

export default component.exports